export default __webpack_public_path__ + "static/media/info.9bbb0ff9.svg";